import { resolveValue } from '../../../utils';
export const createActionCache = (callAPI)=>async (state)=>{
        const url = await resolveValue(state)(callAPI.endpoint);
        return {
            cacheKey: `${callAPI.method}_${url}`,
            // By default zero that means, we won't cache anything
            staleTime: 0,
            clearCacheAfterError: true,
            ...callAPI.cache
        };
    };
